/* Provencelia — tiroir de panier. Mis à jour le 17/08/2026 (libellé « Frais de livraison » le 28/09/2026).

   1. Titre « Panier (n articles) ».
   2. Prix barré « avant promo » sur les lignes en promotion.
   3. Récapitulatif Sous-total / Réduction / Frais de livraison estimés / Total.
   4. Délai de livraison sous la ligne de livraison.
   5. Code promo saisissable dans le panier.
   6. « Ajouter une note » sur la même ligne que le code promo.
   7. Deux mentions de réassurance, dont une ouvre une fenêtre
      d'explication (marche à suivre en cas d'avarie).
   8. Moyens de paiement repris du pied de page.
   9. Conditions de l'offre BOGOS recentrées sous la jauge.

   Sources côté Shopify :
   - /cart.js                     panier, prix payés, poids total
   - /cart/update.js              application des codes promo
   - /products/<h>?view=pv-prix   prix avant promo (metafield
                                  custom.regular_price, absent de l'API
                                  Ajax) — voir templates/product.pv-prix.liquid

   Deux valeurs sont recopiées en dur, le délai de livraison et la grille
   tarifaire. Chacune porte son mode d'emploi juste au-dessus, et la
   tâche planifiée du 3 de chaque mois vérifie qu'elles n'ont pas dérivé.

   Pour tout désactiver : retirer la ligne panier-recap.js de layout/theme.liquid.
*/

(function () {
  'use strict';

  /* Délai affiché sous la ligne de livraison.
     Mesuré sur les livraisons réellement effectuées : médiane et 80e
     centile du délai commande -> livraison constatée. Calibré en août
     2026 sur juillet 2026 (dernier mois complet) : GLS 6-9 j sur 909
     livraisons, DSV 8-12 j sur 1 088, soit 7 à 11 jours en pondéré.
     La borne haute est volontairement portée à 14 jours : mieux vaut
     annoncer large et livrer plus tôt que l'inverse (arbitrage Anicée,
     août 2026). La borne basse reste à 7 jours, elle correspond au réel
     GLS. */
  var DELAI = {
    fr: 'Livré sous 7 à 14 jours',
    en: 'Delivered in 7 to 14 days'
  };

  /* GRILLE TARIFAIRE, zone « France + Monaco » du profil d'expédition
     « Profil général ». Relevée le 17/08/2026 sur l'API Admin.

     POURQUOI EN DUR PLUTÔT QU'EN LIGNE :
     les versions précédentes interrogeaient /cart/shipping_rates.json.
     Cet endpoint s'est révélé inutilisable pour un affichage permanent.
     Il sert un cache de 15 minutes, répond « 202 Accepted » avec une
     liste VIDE quand le calcul n'est pas prêt, et reste muet quand une
     session l'appelle trop souvent : d'où un tarif visible sur un
     appareil et absent sur un autre, pour le même panier au même
     instant. La voie asynchrone documentée (prepare + async) n'a pas
     mieux répondu, tout en coûtant jusqu'à onze requêtes par ouverture
     du tiroir.
     Contre-épreuve du 17/08/2026 : pour 51 kg à Paris 75001, l'API Admin
     renvoie bien « Livraison par DSV, 29,90 € ». La grille est donc
     juste et le checkout trouvera toujours un tarif ; c'est le canal
     Ajax du panier qui n'est pas fiable.
     On calcule donc sur place : instantané, aucune requête, aucune
     attente, et le montant est celui que le client verra au paiement.

     CONTREPARTIE À CONNAÎTRE : si les tarifs changent dans Shopify,
     cette table ne le sait pas. La tâche planifiée du 3 de chaque mois
     la compare au profil d'expédition réel et signale tout écart. En cas
     de changement de tarifs, c'est ICI qu'il faut le répercuter.

     Lecture : jusqu'à 40 kg, deux transporteurs desservent la zone, GLS
     à 9,90 € et DSV à 24,90 € ; on annonce donc « à partir de 9,90 € ».
     Au-delà, DSV est seul et le tarif est ferme. Les poids sont en
     grammes, comme total_weight dans /cart.js.

     EXCEPTION GLS (ajout du 28/09/2026) : au paiement, GLS n'est proposé
     que si TOUS les produits du panier ont « GLS » dans leur metafield
     custom.shipping (« Shipping Provider »). Un seul produit en
     « DB SCHENKER » (Eiffel 42x63, par exemple) et il ne reste que DSV,
     à 24,90 € jusqu'à 40 kg : c'est la colonne « dsv » ci-dessous.
     L'information vient du tiroir (snippets/pv-panier-complements, attribut
     data-gls), car /cart.js ne donne pas les metafields. */
  var TARIFS = [
    { jusqua: 40000,    min: 990,  nb: 2, dsv: 2490 },
    { jusqua: 80000,    min: 2990, nb: 1 },
    { jusqua: 120000,   min: 3990, nb: 1 },
    { jusqua: 160000,   min: 4990, nb: 1 },
    { jusqua: Infinity, min: 5990, nb: 1 }
  ];

  /* Pays couverts par cette grille. Ailleurs, aucune estimation n'est
     affichée et la ligne repasse à « calculée à l'étape suivante » : les
     autres zones ont leurs propres tarifs, et annoncer un montant faux
     serait pire que ne rien annoncer. */
  var PAYS_COUVERTS = { FR: true, MC: true };

  /* Mémoire des codes tapés à la main par le client, le temps de sa visite.
     POURQUOI : le BOGOS applique tout seul un code au panier (BOGOS-xxxx).
     Sans cette mémoire, ce code automatique recevait une pastille
     « Retirer » — le client pouvait donc supprimer lui-même sa remise de
     -10 %, et la réduction s'affichait trois fois (badge du thème,
     ligne du récapitulatif, pastille). On ne propose désormais le retrait
     que pour un code que le client a réellement saisi. */
  var MEMOIRE = 'pv_codes_manuels';

  var cacheRegulier = {};
  var enCours = false;
  var minuteur = null;
  var promoOuvert = false;
  var promoMessage = null;
  var promoEnvoi = false;

  /* Mentions de réassurance. Pour changer le texte, c'est ici.
     Dessins inspirés du pot RICHELIEU : bourrelet, panse, socle.
     Affichées en deux colonnes, icône 26 px et légende dessous
     (mise en page dans assets/panier-quantite.css § 5).

     lienFr / lienEn : fragment cliquable, souligné en pointillé, qui
     ouvre la fenêtre d'explication. Ce fragment doit être le DÉBUT
     EXACT de fr / en, espace insécable comprise, sinon il est ignoré et
     la phrase s'affiche telle quelle, sans rien de cliquable.

     Le contenu de la fenêtre suit la procédure SAV interne
     (Odoo, TUTORIELS > SAV > Casse ou fissure, article 417). */
  var REASSURANCE = [
    {
      svg: '<path d="M4.3 6.4H19.7L18 8.1H6Z"/>'
         + '<path d="M6 8.1c-.6 4.1-.1 7.7 2.9 10.1h6.2c3-2.4 3.5-6 2.9-10.1"/>'
         + '<path d="M9.3 18.2 8.6 20.6h6.8l-.7-2.4"/>'
         + '<path d="m9.6 12.9 1.8 1.8 3.2-3.4"/>',
      fr: 'Cassé à la livraison ? On remplace ou on rembourse.',
      en: 'Broken on arrival? We replace it or refund you.',
      lienFr: 'Cassé à la livraison ?',
      lienEn: 'Broken on arrival?',
      modale: {
        titreFr: 'Avarie de transport : notre engagement',
        corpsFr: [
          'Nos expéditions sont préparées et protégées pour le transport. Les avaries restent rares, et elles sont prises en charge par Provencelia.',
          'À la réception, nous vous invitons à examiner le colis avant de signer. En cas de dommage visible, mentionnez-le sur le bon de livraison présenté par le transporteur, ou refusez la livraison.',
          'Si vous constatez la casse au déballage, transmettez-nous des photographies du produit ainsi que du bon de livraison, lorsque vous en disposez.',
          'Nous procédons alors au remplacement du produit ou à son remboursement. La réclamation auprès du transporteur est traitée par nos équipes.'
        ],
        titreEn: 'Transport damage: our commitment',
        corpsEn: [
          'Our shipments are prepared and protected for transport. Damage remains rare, and it is covered by Provencelia.',
          'On receipt, please examine the parcel before signing. If the damage is visible, note it on the delivery note handed over by the carrier, or refuse the delivery.',
          'Should you find the damage while unpacking, send us photographs of the product and of the delivery note, where one was provided.',
          'We then arrange the replacement or the refund of the product. The claim with the carrier is handled by our team.'
        ]
      }
    },
    {
      svg: '<path d="M16.8 9.6v5.9L10.9 18.9 5 15.5V9.6l5.9-3.4 5.9 3.4Z"/>'
         + '<path d="M5 9.6l5.9 3.4 5.9-3.4M10.9 13v5.9"/>'
         + '<circle cx="18.8" cy="6" r="2.4"/>',
      fr: 'Colis suivi, du départ à votre porte.',
      en: 'Tracked parcel, from our door to yours.'
    }
  ];

  function racine() {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
    } catch (e) {}
    return '/';
  }

  function estFr() {
    return (document.documentElement.lang || 'fr').toLowerCase().indexOf('fr') === 0;
  }

  var T = {
    sousTotal:  function () { return estFr() ? 'Sous-total' : 'Subtotal'; },
    reduction:  function () { return estFr() ? 'Réduction' : 'Discount'; },
    livraison:  function () { return estFr() ? 'Frais de livraison estimés' : 'Estimated shipping costs'; },
    aPartir:    function () { return estFr() ? 'Frais de livraison à partir de' : 'Shipping costs from'; },
    total:      function () { return estFr() ? 'Total' : 'Total'; },
    plusTard:   function () { return estFr() ? 'calculés à l\'étape suivante' : 'calculated at checkout'; },
    ouvrir:     function () { return estFr() ? 'Code promo' : 'Promo code'; },
    champ:      function () { return estFr() ? 'Votre code' : 'Your code'; },
    appliquer:  function () { return estFr() ? 'Appliquer' : 'Apply'; },
    retirer:    function () { return estFr() ? 'Retirer' : 'Remove'; },
    fermer:     function () { return estFr() ? 'Fermer' : 'Close'; },
    invalide:   function () { return estFr() ? 'Ce code n\'est pas valable pour ce panier.' : 'This code is not valid for this cart.'; },
    erreur:     function () { return estFr() ? 'Impossible de vérifier ce code pour le moment.' : 'Could not check this code right now.'; },
    envoi:      function () { return estFr() ? 'Vérification…' : 'Checking…'; },
    article:    function (n) {
      if (estFr()) return n > 1 ? n + ' articles' : n + ' article';
      return n > 1 ? n + ' items' : n + ' item';
    }
  };

  function argent(centimes) {
    var s = (Math.round(Math.abs(centimes)) / 100).toFixed(2);
    var t = estFr() ? s.replace('.', ',') + '€' : '€' + s;
    return centimes < 0 ? '-' + t : t;
  }

  /* ---------- livraison, calculée sur place ---------- */

  function paysDuVisiteur() {
    try {
      if (window.Shopify && window.Shopify.country) {
        return String(window.Shopify.country).toUpperCase();
      }
    } catch (e) {}
    return 'FR';
  }

  /* GLS possible pour ce panier ? Lu dans le tiroir (voir EXCEPTION GLS).
     Sans l'information, on garde le comportement d'avant. */
  function glsPossible() {
    var el = document.querySelector('#cart-drawer [data-pv-livraison]');
    return !el || el.getAttribute('data-gls') !== 'false';
  }

  function tarifPourPoids(poids) {
    if (!PAYS_COUVERTS[paysDuVisiteur()]) return null;
    var p = typeof poids === 'number' ? poids : 0;
    for (var i = 0; i < TARIFS.length; i++) {
      var t = TARIFS[i];
      if (p <= t.jusqua) {
        if (t.nb > 1 && t.dsv && !glsPossible()) return { min: t.dsv, nb: 1 };
        return { min: t.min, nb: t.nb };
      }
    }
    return null;
  }

  /* ---------- codes promo saisis à la main ---------- */

  function codesManuels() {
    try { return JSON.parse(sessionStorage.getItem(MEMOIRE) || '[]'); } catch (e) { return []; }
  }

  function memoriserCode(code) {
    try {
      var l = codesManuels();
      if (l.indexOf(code) < 0) l.push(code);
      sessionStorage.setItem(MEMOIRE, JSON.stringify(l));
    } catch (e) {}
  }

  function oublierCodes() {
    try { sessionStorage.removeItem(MEMOIRE); } catch (e) {}
  }

  function codesActifs(panier) {
    return (panier.discount_codes || []).filter(function (c) { return c.applicable; });
  }

  /* Renvoie le code que le client a tapé lui-même, s'il est encore actif.
     Les codes appliqués automatiquement par une application renvoient null. */
  function codeDuClient(panier) {
    var actifs = codesActifs(panier);
    var manuels = codesManuels();
    for (var i = 0; i < actifs.length; i++) {
      if (manuels.indexOf(actifs[i].code) >= 0) return actifs[i].code;
    }
    return null;
  }

  /* ---------- titre : Panier (n articles) ---------- */

  function titrePanier(panier) {
    var t = document.querySelector('#cart-drawer [slot="header"]');
    if (!t) return;
    if (!t.getAttribute('data-pv-base')) {
      t.setAttribute('data-pv-base', (t.textContent || '').replace(/\s*\([^)]*\)\s*$/, '').trim());
    }
    var base = t.getAttribute('data-pv-base');
    var n = panier.item_count || 0;
    var voulu = n ? base + ' (' + T.article(n) + ')' : base;
    if (t.textContent !== voulu) t.textContent = voulu;
  }

  /* ---------- prix barré « avant promo » ---------- */

  function handleDe(el) {
    var p = el;
    for (var i = 0; i < 6 && p; i++) {
      var a = p.querySelector && p.querySelector('a[href*="/products/"]');
      if (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
        if (m) return decodeURIComponent(m[1]);
      }
      p = p.parentElement;
    }
    return null;
  }

  function prixRegulier(handle) {
    if (Object.prototype.hasOwnProperty.call(cacheRegulier, handle)) {
      return Promise.resolve(cacheRegulier[handle]);
    }
    return fetch(racine() + 'products/' + encodeURIComponent(handle) + '?view=pv-prix',
                 { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (txt) {
        var v = null;
        try {
          var j = JSON.parse((txt || '').trim());
          if (typeof j.regular === 'number') v = j.regular;
        } catch (e) {}
        cacheRegulier[handle] = v;
        return v;
      })
      .catch(function () { cacheRegulier[handle] = null; return null; });
  }

  function prixBarres(panier) {
    var listes = document.querySelectorAll('#cart-drawer .cart-drawer__items price-list');
    for (var i = 0; i < listes.length; i++) {
      (function (pl) {
        if (pl.querySelector('.pv-prix-barre')) return;
        var h = handleDe(pl);
        if (!h) return;
        var item = null;
        for (var k = 0; k < panier.items.length; k++) {
          if (panier.items[k].handle === h) { item = panier.items[k]; break; }
        }
        if (!item) return;

        prixRegulier(h).then(function (reg) {
          /* Garde-fou : le prix barré ne s'affiche que s'il est SUPÉRIEUR
             au prix payé. Sans cela, un prix de référence saisi hors
             taxes afficherait un « barré » moins cher que le prix réglé. */
          if (!reg || reg <= item.price) return;
          if (pl.querySelector('.pv-prix-barre')) return;
          var s = document.createElement('s');
          s.className = 'pv-prix-barre';
          s.textContent = argent(reg);
          pl.appendChild(s);
          pl.classList.add('pv-prix-promo');
        });
      })(listes[i]);
    }
  }

  function ligne(libelle, valeur, modificateur) {
    var d = document.createElement('div');
    d.className = 'pv-recap__row' + (modificateur ? ' pv-recap__row--' + modificateur : '');
    var a = document.createElement('span');
    a.className = 'pv-recap__l';
    a.textContent = libelle;
    var b = document.createElement('span');
    b.className = 'pv-recap__v';
    b.textContent = valeur;
    d.appendChild(a);
    d.appendChild(b);
    return d;
  }

  /* ---------- conditions de l'offre, centrées sous la jauge ---------- */

  function jaugeNote() {
    var conteneur = document.querySelector('#cart-drawer .bogos-progress-bar-container');
    if (!conteneur) return;
    var src = conteneur.querySelector('.bogos-progress-goal-description');
    if (!src) return;
    var texte = (src.textContent || '').trim();
    if (!texte) return;

    var el = conteneur.querySelector('.pv-jauge-note');
    if (!el) {
      el = document.createElement('p');
      el.className = 'pv-jauge-note';
      conteneur.appendChild(el);
    }
    if (el.textContent !== texte) el.textContent = texte;
  }

  /* ---------- code promo ---------- */

  function envoyerCode(code) {
    if (promoEnvoi) return;
    promoEnvoi = true;
    promoMessage = T.envoi();
    majZonePromo();

    fetch(racine() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        var codes = (panier && panier.discount_codes) || [];
        var ok = false;
        for (var i = 0; i < codes.length; i++) {
          if (codes[i].applicable) ok = true;
        }
        if (code && !ok) {
          promoMessage = T.invalide();
          oublierCodes();
          return fetch(racine() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ discount: '' })
          });
        }
        if (code) { memoriserCode(code); } else { oublierCodes(); }
        promoMessage = null;
        promoOuvert = false;
        return null;
      })
      .catch(function () { promoMessage = T.erreur(); })
      .then(function () {
        promoEnvoi = false;
        majAffichage(true);
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
      });
  }

  function zonePromo(panier, pied) {
    var zone = document.createElement('div');
    zone.className = 'pv-promo';

    var rangee = document.createElement('div');
    rangee.className = 'pv-promo__links';
    zone.appendChild(rangee);

    var noteBtn = pied.querySelector('.link-faded-reverse');
    var noteDlg = pied.querySelector('cart-note-dialog');
    if (noteBtn) rangee.appendChild(noteBtn);

    var monCode = codeDuClient(panier);

    if (!monCode && !promoOuvert) {
      var lien = document.createElement('button');
      lien.type = 'button';
      lien.className = 'pv-promo__toggle';
      lien.textContent = T.ouvrir();
      lien.addEventListener('click', function () {
        promoOuvert = true;
        promoMessage = null;
        majZonePromo(true);
      });
      rangee.appendChild(lien);
    }

    if (monCode) {
      var chip = document.createElement('div');
      chip.className = 'pv-promo__applied';
      var nom = document.createElement('span');
      nom.className = 'pv-promo__code';
      nom.textContent = monCode;
      var retirer = document.createElement('button');
      retirer.type = 'button';
      retirer.className = 'pv-promo__remove';
      retirer.textContent = T.retirer();
      retirer.addEventListener('click', function () { envoyerCode(''); });
      chip.appendChild(nom);
      chip.appendChild(retirer);
      zone.appendChild(chip);
    } else if (promoOuvert) {
      var form = document.createElement('div');
      form.className = 'pv-promo__form';

      var champ = document.createElement('input');
      champ.type = 'text';
      champ.className = 'pv-promo__input';
      champ.placeholder = T.champ();
      champ.setAttribute('autocomplete', 'off');
      champ.setAttribute('spellcheck', 'false');
      champ.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
          if (champ.value.trim()) envoyerCode(champ.value.trim());
        }
      });

      var go = document.createElement('button');
      go.type = 'button';
      go.className = 'pv-promo__go';
      go.textContent = T.appliquer();
      go.disabled = promoEnvoi;
      go.addEventListener('click', function () {
        if (champ.value.trim()) envoyerCode(champ.value.trim());
      });

      form.appendChild(champ);
      form.appendChild(go);
      zone.appendChild(form);
    }

    if (promoMessage) {
      var msg = document.createElement('p');
      msg.className = 'pv-promo__msg';
      msg.textContent = promoMessage;
      zone.appendChild(msg);
    }

    if (noteDlg) zone.appendChild(noteDlg);

    var vs = pied.querySelector('.v-stack');
    if (vs && !vs.querySelector('button, cart-note-dialog')) vs.style.display = 'none';

    return zone;
  }

  function majZonePromo(focus) {
    var pied = document.querySelector('#cart-drawer .cart-drawer__footer');
    var recap = pied && pied.querySelector('.pv-recap');
    if (!recap) return;
    var ancienne = recap.querySelector('.pv-promo');
    if (!ancienne) return;
    fetch(racine() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        if (!panier) return;
        var neuve = zonePromo(panier, pied);
        ancienne.parentNode.replaceChild(neuve, ancienne);
        if (focus) {
          var i = neuve.querySelector('.pv-promo__input');
          if (i) i.focus();
        }
      })
      .catch(function () {});
  }

  /* ---------- fenêtre d'explication ---------- */

  /* <dialog> posé sur <body> et non dans le tiroir : showModal() le place
     dans la « top layer », donc au-dessus du tiroir et de la bulle de chat
     sans bataille de z-index, et Échap le referme lui d'abord. Repli
     prévu pour les navigateurs sans showModal (classe pv-modale--repli). */

  function fermerModale(d) {
    if (typeof d.close === 'function' && d.open) { d.close(); return; }
    d.removeAttribute('open');
  }

  function ouvrirModale(m) {
    var d = document.getElementById('pv-modale');
    if (!d) {
      d = document.createElement('dialog');
      d.id = 'pv-modale';
      d.className = 'pv-modale';
      if (typeof d.showModal !== 'function') d.className += ' pv-modale--repli';
      d.addEventListener('click', function (e) {
        /* Un clic sur le fond : la cible est le <dialog> lui-même,
           jamais un élément intérieur. */
        if (e.target === d) fermerModale(d);
      });
      document.body.appendChild(d);
    }

    var titre = estFr() ? m.titreFr : m.titreEn;
    var corps = estFr() ? m.corpsFr : m.corpsEn;

    while (d.firstChild) d.removeChild(d.firstChild);

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'pv-modale__x';
    x.setAttribute('aria-label', T.fermer());
    x.textContent = '×';
    x.addEventListener('click', function () { fermerModale(d); });
    d.appendChild(x);

    var box = document.createElement('div');
    box.className = 'pv-modale__in';

    var h = document.createElement('p');
    h.className = 'pv-modale__t';
    h.textContent = titre;
    box.appendChild(h);

    for (var i = 0; i < corps.length; i++) {
      var p = document.createElement('p');
      p.textContent = corps[i];
      box.appendChild(p);
    }

    d.appendChild(box);

    if (typeof d.showModal === 'function') { d.showModal(); } else { d.setAttribute('open', ''); }
  }

  /* ---------- réassurance ---------- */

  function reassurance(pied) {
    if (pied.querySelector('.pv-rea')) return;
    var box = document.createElement('div');
    box.className = 'pv-rea';

    for (var i = 0; i < REASSURANCE.length; i++) {
      (function (r) {
        var l = document.createElement('div');
        l.className = 'pv-rea__l';
        l.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" '
                    + 'stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" '
                    + 'aria-hidden="true" focusable="false">' + r.svg + '</svg>';

        var s = document.createElement('span');
        var texte = estFr() ? r.fr : r.en;
        var frag = estFr() ? r.lienFr : r.lienEn;

        if (r.modale && frag && texte.indexOf(frag) === 0) {
          var b = document.createElement('button');
          /* type="button" obligatoire : le pied de panier est un <form>,
             un bouton sans type l'enverrait vers /cart au clic. */
          b.type = 'button';
          b.className = 'pv-rea__plus';
          b.setAttribute('aria-haspopup', 'dialog');
          b.textContent = frag;
          b.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            ouvrirModale(r.modale);
          });
          s.appendChild(b);
          s.appendChild(document.createTextNode(texte.slice(frag.length)));
        } else {
          s.textContent = texte;
        }

        l.appendChild(s);
        box.appendChild(l);
      })(REASSURANCE[i]);
    }
    pied.appendChild(box);
  }

  /* ---------- moyens de paiement ---------- */

  function paiements(pied) {
    if (pied.querySelector('.pv-paiements')) return;
    var src = document.querySelector('.payment-methods');
    if (!src) return;
    var box = document.createElement('div');
    box.className = 'pv-paiements';
    var clone = src.cloneNode(true);
    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');
    box.appendChild(clone);
    pied.appendChild(box);
  }

  /* ---------- rendu ---------- */

  function rendre(panier) {
    var pied = document.querySelector('#cart-drawer .cart-drawer__footer');
    if (!pied) return;
    var groupe = pied.querySelector('.button-group');
    if (!groupe) return;

    var livraison = tarifPourPoids(panier.total_weight);

    var bloc = document.createElement('div');
    bloc.className = 'pv-recap';

    /* Sous-total AVANT remises (original_total_price) : la remise automatique
       « -15 % dès 500 € de pots » s'applique ligne par ligne, et sans cela elle
       serait déjà fondue dans le sous-total, sans ligne « Réduction » visible. */
    var sousTotal = typeof panier.original_total_price === 'number'
      ? panier.original_total_price
      : (typeof panier.items_subtotal_price === 'number' ? panier.items_subtotal_price : panier.total_price);
    var remise = Math.max(0, sousTotal - panier.total_price);

    bloc.appendChild(ligne(T.sousTotal(), argent(sousTotal)));

    if (remise > 0) {
      /* On ne nomme le code que si le client l'a saisi. Les codes générés
         par le BOGOS (BOGOS-CgYF40…) ne parlent à personne : la ligne
         indique simplement « Réduction ». */
      var monCode = codeDuClient(panier);
      var etiquette = monCode ? T.reduction() + ' ' + monCode : T.reduction();
      bloc.appendChild(ligne(etiquette, argent(-remise), 'remise'));
    }

    if (livraison) {
      var multiple = livraison.nb > 1;
      bloc.appendChild(ligne(multiple ? T.aPartir() : T.livraison(), argent(livraison.min)));

      var d = document.createElement('p');
      d.className = 'pv-recap__delai';
      d.textContent = estFr() ? DELAI.fr : DELAI.en;
      bloc.appendChild(d);

      bloc.appendChild(ligne(T.total(), argent(panier.total_price + livraison.min), 'total'));
      pied.classList.add('pv-recap-actif');
    } else {
      bloc.appendChild(ligne(T.livraison(), T.plusTard()));
      bloc.appendChild(ligne(T.total(), argent(panier.total_price), 'total'));
      pied.classList.remove('pv-recap-actif');
    }

    /* La zone promo récupère le bouton de note : on la construit AVANT de
       retirer l'ancien récapitulatif, sinon le bouton serait détruit. */
    bloc.appendChild(zonePromo(panier, pied));

    var ancien = pied.querySelector('.pv-recap');
    if (ancien && ancien.parentNode) ancien.parentNode.removeChild(ancien);

    pied.insertBefore(bloc, groupe);
    reassurance(pied);
    paiements(pied);
    jaugeNote();
    titrePanier(panier);
    prixBarres(panier);
  }

  function majAffichage(force) {
    if (enCours && !force) return;
    var pied = document.querySelector('#cart-drawer .cart-drawer__footer');
    if (!pied || !pied.querySelector('.button-group')) return;

    enCours = true;
    fetch(racine() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        if (!panier || !panier.item_count) return;
        if (panier.currency && panier.currency !== 'EUR') return;
        rendre(panier);
      })
      .catch(function () {})
      .then(function () { enCours = false; });
  }

  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(function () { majAffichage(); jaugeNote(); }, 150);
  }

  function surveiller() {
    var tiroir = document.getElementById('cart-drawer');
    if (!tiroir || typeof MutationObserver === 'undefined') return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'attributes') { planifier(); return; }
      }
      var pied = document.querySelector('#cart-drawer .cart-drawer__footer');
      if (pied && !pied.querySelector('.pv-recap')) { planifier(); return; }
      var conteneur = document.querySelector('#cart-drawer .bogos-progress-bar-container');
      if (conteneur
        && conteneur.querySelector('.bogos-progress-goal-description')
        && !conteneur.querySelector('.pv-jauge-note')) {
        jaugeNote();
      }
    }).observe(tiroir, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'style']
    });
  }

  function demarrer() {
    surveiller();
    planifier();
  }

  document.addEventListener('cart:updated', planifier);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();